import classNames from "classnames";
import { useGlobalFilterContext } from "contexts/GlobalFilterContext";
import copy from "copy-to-clipboard";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import LinkIcon from "ac-components/ac-icons/LinkIcon";
import TickIcon from "ac-components/ac-icons/TickIcon";

import "./ACGlobalFilterUrlButton.less";

export default function ACGlobalFilterUrlButton() {
  const [copied, setCopied] = useState(false);
  const globalFilterContext = useGlobalFilterContext();
  const location = useLocation();
  const getCopyUrl = () => {
    const params = new URLSearchParams();
    params.append(
      "p",
      globalFilterContext.globalFilterProducts?.join(",") ?? "",
    );
    params.append(
      "sp",
      globalFilterContext.globalFilterSubProducts?.join(",") ?? "",
    );
    params.append(
      "c",
      globalFilterContext.globalFilterToolCategories?.join(",") ?? "",
    );
    params.append("g", globalFilterContext.globalFilterGroups?.join(",") ?? "");
    params.append("target", location.pathname + (location.search || ""));
    return `${window.location.origin}/#/session-redirect?${params.toString()}`;
  };
  const copyUrl = () => {
    if (copied) {
      return;
    }
    copy(getCopyUrl());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div
      className={classNames("ac-global-filter-url-button", { copied })}
      data-copyurl={getCopyUrl()}
      onClick={copyUrl}
    >
      <span className="ac-global-filter-url-button-icon">
        {copied ? <TickIcon /> : <LinkIcon />}
      </span>
      {copied ? (
        <span>Copied!</span>
      ) : (
        <span className="ac-global-filter-url-button-text">Copy link</span>
      )}
    </div>
  );
}
